import { useSelector } from 'react-redux'
import { get } from './reducers'

/*
const SCHEMA = {
    "/api/movies/": {
        "thumbnail": "/api/images/"
    },
    "/api/profiles/": {
        "thumbnail": "/api/images/"
    },
    "/api/reviews/": {
        "movie": "/api/movies/",
        "profile": "/api/movies/",
        "seenWithProfiles": "/api/profiles/",
        "seenWithOutsiders": "/api/profiles/"
    }
}*/


const useObjectSelector = (objectId) => useSelector(store => {
    if (objectId in store.objectsReducer.objects && store.objectsReducer.objects[objectId].status === "fulfilled") {
        return store.objectsReducer.objects[objectId].data
    }
    else { return "UNKNOWN" }
})

const getObject = (objectId, selector, dispatch) => (() => {
    const r = selector
    if (r === "UNKNOWN") {
        dispatch(get(objectId))
        return "UNKNOWN"
    }
    else
        return r
})

const useNestedObjectSelector = (objectId, nestedObjectIdCreator) => useSelector(store => {
    if (objectId in store.objectsReducer.objects && store.objectsReducer.objects[objectId].status === "fulfilled") {
        const nestedObjectId = nestedObjectIdCreator(store.objectsReducer.objects[objectId].data)
        if (nestedObjectId in store.objectsReducer.objects && store.objectsReducer.objects[nestedObjectId].status === "fulfilled") {
            return store.objectsReducer.objects[nestedObjectId].data
        }
    }
    return "UNKNOWN"
})

const getNestedObject = (getRoot, idCreator, selector, dispatch) => (() => {
    if (getRoot() === "UNKNOWN") {
        return "UNKNOWN"
    }
    const r = selector
    if (r === "UNKNOWN") {
        dispatch(get(idCreator()))
        return "UNKNOWN"
    }
    else {
        return r
    }
})

const useNestedNestedObjectSelector = (objectId, nestedObjectIdCreator, nestedNestedObjectIdCreator) => useSelector(store => {
    if (objectId in store.objectsReducer.objects && store.objectsReducer.objects[objectId].status === "fulfilled") {
        const nestedObjectId = nestedObjectIdCreator(store.objectsReducer.objects[objectId].data)
        if (nestedObjectId in store.objectsReducer.objects && store.objectsReducer.objects[nestedObjectId].status === "fulfilled") {
            const nestedNestedObjectId = nestedNestedObjectIdCreator(store.objectsReducer.objects[nestedObjectId].data)
            if (nestedNestedObjectId in store.objectsReducer.objects && store.objectsReducer.objects[nestedNestedObjectId].status === "fulfilled")
                return store.objectsReducer.objects[nestedNestedObjectId].data
        }
    }
    return "UNKNOWN"
})

const getNestedNestedObject = (getRoot, idCreator, selector, dispatch) => getNestedObject(getRoot, idCreator, selector, dispatch)

export { useObjectSelector, getObject, useNestedObjectSelector, getNestedObject, useNestedNestedObjectSelector, getNestedNestedObject }